import { queryOptions } from '@tanstack/react-query';

import { ONE_HOUR } from '@/constants/time';
import { components } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type Subspecialty = NonNullable<
  components['schemas']['SubspecialtiesResponse']['data']
>[number];

export async function getSubspecialties() {
  const { data } = await fetchClient.GET('/v2/subspecialties');

  const subspecialties = data?.data || [];

  return subspecialties as Subspecialty[];
}

export const getSubspecialtiesQueryOptions = () =>
  queryOptions({
    queryKey: ['subspecialties'],
    queryFn: getSubspecialties,
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
  });
